"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryRoute = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var matches_query_1 = require("./matches-query");
/**
 * The public API for matching a search/query and rendering.
 */
// @ts-ignore:next-line
var QueryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(QueryRoute, _super);
    function QueryRoute() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.state = {
            matchesQuery: _this.computeMatch(_this.props),
        };
        return _this;
    }
    QueryRoute.prototype.computeMatch = function (details) {
        var queryMatch = details.queryMatch, query = details.query, history = details.history;
        var search = this.props.search || history.location.search;
        // If QuerySwitch has already processed this as a match, no need for duplication of effort.
        if (queryMatch) {
            return true;
        }
        var doesMatch = query ? (0, matches_query_1.matchesQuery)(search, query) : false;
        return doesMatch;
    };
    QueryRoute.prototype.UNSAFE_componentWillMount = function () {
        var _this = this;
        var history = this.props.history;
        this.unlisten = history.listen(function () {
            var doesMatchQuery = _this.computeMatch(_this.props);
            if (_this.state.matchesQuery !== doesMatchQuery) {
                _this.setState({ matchesQuery: doesMatchQuery });
            }
        });
    };
    QueryRoute.prototype.componentWillUnmount = function () {
        this.unlisten();
    };
    QueryRoute.prototype.render = function () {
        // eslint-disable-next-line react/prop-types
        var children = this.props.children;
        if (!this.state.matchesQuery) {
            return null;
        }
        return children;
    };
    QueryRoute = tslib_1.__decorate([
        react_router_dom_1.withRouter
    ], QueryRoute);
    return QueryRoute;
}(React.Component));
exports.QueryRoute = QueryRoute;
//# sourceMappingURL=query-route.js.map